import { Form } from "react-bootstrap"

interface SelectSpecimenCollectionProps {
  selectedValue?: string
  disabled?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function SelectSpecimenCollection(props: SelectSpecimenCollectionProps) {
  const { selectedValue, disabled, onChange } = props

  return (
    <Form.Group>
      <Form.Check
        inline
        label="SINGLE"
        id="single-radio"
        type="radio"
        name="reqSpecimenCollection"
        className="font-weight-bold abc-radio"
        value="single"
        disabled={disabled}
        checked={selectedValue === "single"}
        onChange={onChange}
      />
      <Form.Check
        inline
        label="SPLIT"
        id="split-radio"
        type="radio"
        name="reqSpecimenCollection"
        className="font-weight-bold abc-radio"
        value="split"
        checked={selectedValue === "split"}
        onChange={onChange}
      />
    </Form.Group>
  )
}

SelectSpecimenCollection.defaultProps = {
  selectedValue: "",
  disabled: false,
}

export default SelectSpecimenCollection
